import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTravelContext } from "misc/TravelContext";
import { Delivery } from "typings/models";
import DeliveryCard from "pages/delivery/DeliveryCard";
import { Box, Typography, Grid2 as Grid, Button } from "@mui/material";
import { formatDate } from 'misc/dateUtils';

const DeliveryPage: React.FC = () => {
    const navigate = useNavigate();
    const {
        route,
        driver,
        setOrder,
        setRoute,
        deliveryGroup,
        order,
    } = useTravelContext();

    const isCompleted = deliveryGroup?.status === 'Completed';
    const deliveryStart = !isCompleted ? deliveryGroup?.created_at : null;

    let timeStr: string | null = null;
    if (deliveryStart) {
        const currentTime = new Date().getTime() + (new Date().getTimezoneOffset() * 60000);
        const timeElapsed = currentTime - new Date(deliveryStart).getTime();
        const hoursElapsed = Math.floor(timeElapsed / 3600000);
        const minutesElapsed = Math.floor((timeElapsed % 3600000) / 60000);
        timeStr = `${hoursElapsed} h ${minutesElapsed} m`;
    }

    const [timeElapsedString, setTimeElapsedString] = useState<string | null>(timeStr);

    useEffect(() => {
        if (!deliveryStart) return;
        const interval = setInterval(() => {
            const currentTime = new Date().getTime() + (new Date().getTimezoneOffset() * 60000);
            const timeElapsed = currentTime - new Date(deliveryStart).getTime();
            const hoursElapsed = Math.floor(timeElapsed / 3600000);
            const minutesElapsed = Math.floor((timeElapsed % 3600000) / 60000);
            setTimeElapsedString(`${hoursElapsed}h ${minutesElapsed}m`);
        }, 6000);
        return () => clearInterval(interval);
    }, [deliveryStart]);

    const handleCompleteDeliveries = () => {
        setOrder(null);
        setRoute(null);
        navigate("/orders");
    }
    
    const deliveries = deliveryGroup?.deliveries;

    const finishedDeliveries = deliveries?.filter((delivery: Delivery) => delivery.status === "Completed" || delivery.status === "Failed");
    const inProgressDeliveries = deliveries?.filter((delivery: Delivery) => delivery.status === "In Progress");
    const deliveriesDisplay = [...(inProgressDeliveries || []), ...(finishedDeliveries || [])].map((delivery: Delivery) => {
        return (<Grid size={12} sx={{ marginTop: "10px" }}>
        <DeliveryCard 
            delivery={delivery} 
            onRegisterDelivery={() => {}} 
            key={delivery.id}
            />
        </Grid>)
    });

    const allDeliveriesCompleted = deliveries?.every((delivery: Delivery) => delivery.status !== "In Progress");

    return (
        <>
        <Grid container>
            
            <Grid size={12} textAlign="center">
            {route && 
            <>
            <Typography variant="h6" gutterBottom textAlign="center">
                {route.id}
            </Typography>
            <Typography gutterBottom textAlign="center">
                {formatDate(route.scheduled_date)}
                </Typography>
            </>
            }
                <Typography variant="h6" gutterBottom sx={{ marginTop: "10px" }}>
                    {timeElapsedString}
                </Typography>
            </Grid>
            <Grid size={12}>
            <Box sx={{ padding: "3px 20px" }} textAlign="center" justifyContent="center">
                {allDeliveriesCompleted && <Button 
                    variant="contained" 
                    color="primary" 
                    sx={{ marginBottom: 2 }}
                    onClick={handleCompleteDeliveries}
                >
                    Completar entregas
                </Button>
                }
                {deliveriesDisplay}
            </Box>
            </Grid>
        </Grid>
        </>
    )
};

export default DeliveryPage;